import { render, staticRenderFns } from "./CustomerFoodSelections.vue?vue&type=template&id=5bc45e82&scoped=true"
import script from "./CustomerFoodSelections.vue?vue&type=script&lang=js"
export * from "./CustomerFoodSelections.vue?vue&type=script&lang=js"
import style0 from "./CustomerFoodSelections.vue?vue&type=style&index=0&id=5bc45e82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc45e82",
  null
  
)

export default component.exports